/**
 * Pessoas.
 *
 * NAO cria pessoa: quem cadastra e o liberty/auth. Aqui se define o que ela e
 * DENTRO do deck -- papel, capacidade semanal, time, e se esta ativa.
 */
export const nav = {
    permissao: 'deck.pessoas:ver',
    section: 'Configuracao',
    title: 'Pessoas',
    icon: 'groups',
    route: '/pessoas',
    sequence: 40,
};

export default [
    {
        path: '/pessoas',
        name: 'pessoas',
        component: () => import('./pages/PessoasPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.pessoas:ver' },
    },
];
